import {
  StyledPopover,
  StyledHeader,
  StyledHeaderIcon,
  StyledContent,
  StyledCTA,
  StyledPopoverElement,
} from './Popover.style';

const Popover = ({ elements = [] }) => {
  return (
    <StyledPopover>
      {elements.map(
        (
          { icon: IconComponent, title, content, linkUrl, buttonText },
          index,
        ) => (
          <StyledPopoverElement key={index} firstElement={index === 0}>
            <StyledHeader>
              <StyledHeaderIcon>
                <IconComponent />
              </StyledHeaderIcon>
              {title}
            </StyledHeader>
            <StyledContent>{content}</StyledContent>
            <StyledCTA onClick={() => window.open(linkUrl, '_blank')}>
              {buttonText}
            </StyledCTA>
          </StyledPopoverElement>
        ),
      )}
    </StyledPopover>
  );
};

export default Popover;
